import { Component, inject, OnInit } from "@angular/core";
import { debounce } from 'lodash-es';
import { FormsModule } from "@angular/forms";
import { NgSelectComponent } from "@ng-select/ng-select";
import { UserSettings } from "app/core/enums/user-settings.enum";
import { LimitOffsetPaging } from "app/core/models/paged-results/limit-offset-paging.model";
import { ClientEspNdcFilters, ClientEspNdcListSettings } from "app/core/models/user-settings/client-esp-ndc-settings.model";
import { ClientEspNdcsService } from "app/core/services/client-esp-ndcs.service";
import { UserSettingsService } from "app/core/services/user-settings.service";
import { PaginationHeaderComponent } from "app/shared/components/pagination-header/pagination-header.component";
import { PaginationComponent } from "app/shared/components/pagination/pagination.component";
import { MatProgressSpinner } from "@angular/material/progress-spinner";
import { ClientEspNdc } from "app/core/models/client-esp-ndc.model";

@Component({
  selector: 'app-client-portal-client-esp-ndcs',
  templateUrl: './client-portal-client-esp-ndcs.component.html',
  styleUrls: ['./client-portal-client-esp-ndcs.component.scss'],
  imports: [
    FormsModule,
    NgSelectComponent,
    PaginationHeaderComponent,
    PaginationComponent,
    MatProgressSpinner,
  ],
})
export class ClientPortalClientEspNdcsComponent implements OnInit {
  private userSettingsService = inject(UserSettingsService);
  private clientEspNdcsService = inject(ClientEspNdcsService);

  clientEspNdcs: ClientEspNdc[] = [];

  paging: LimitOffsetPaging = LimitOffsetPaging.empty;
  filters: ClientEspNdcFilters = new ClientEspNdcFilters();

  manufacturers: string[] = [];

  loading = true;

  ngOnInit() {
    this.loadSettings();
    this.loadManufacturers();
    this.loadClientEspNdcs();
  }

  onFilterChange() {
    this.paging.currentPage = 1;
    this.saveSettings();
    this.loadClientEspNdcs();
  }

  onResetFiltersClick() {
    this.paging.currentPage = 1;
    this.filters = new ClientEspNdcFilters();
    this.saveSettings();
    this.loadClientEspNdcs();
  }

  onPageSizeChange(size: number) {
    this.paging.pageSize = size;
    this.saveSettings();
    this.loadClientEspNdcs();
  }

  onPageChange(_page: number) {
    this.saveSettings();
    this.loadClientEspNdcs();
  }

  private loadSettings() {
    const listSettings: ClientEspNdcListSettings =
      this.userSettingsService.get<ClientEspNdcListSettings>(
        UserSettings.clientPortalClientEspNdcsListSettings
      );

    if (listSettings) {
      this.filters = listSettings.filters;
      this.paging = listSettings.paging;
    }
  }

  private saveSettings() {
    const listSettings = new ClientEspNdcListSettings();
    listSettings.filters = this.filters;
    listSettings.paging = this.paging;
    this.userSettingsService.save<ClientEspNdcListSettings>(
      UserSettings.clientPortalClientEspNdcsListSettings,
      listSettings
    );
  }

  private loadManufacturers() {
    this.clientEspNdcsService.getManufacturers().subscribe(results => this.manufacturers = results);
  }

  private loadClientEspNdcs() {
    this.loading = true;

    this.clientEspNdcsService.getList(this.paging, this.filters).subscribe(result => {
      this.clientEspNdcs = result.clientEspNdcs;
      this.paging = result.meta.paging;
      this.loading = false;
    });
  }

  onFilterChangeWithDebounce() {
    this.debounceFilterKeyUp();
  }

  private debounceFilterKeyUp = debounce(
    () => { this.onFilterChange(); },
    1000,
    { maxWait: 2000 }
  );
}
